module.exports = __webpack_public_path__ + "img/company-background.f6b3a2c0.png";